module.exports = __webpack_public_path__ + "img/IDCard3.c8ef3ccf.png";